import parseUrl from 'url-parse';
import { PRODUCT_STATUS } from './productsStatus';
export function getLink(currentProduct, environment, products, productId, productsStatus, swicusOrgId) {
  var product = products.find(function (p) {
    return p.id === productId;
  });

  if (!swicusOrgId) {
    return createSignUpLink(currentProduct, environment, product);
  } else if (shouldProductRedirectToLogin(productsStatus, productId)) {
    return transformUrl(currentProduct, product.url.login[environment], swicusOrgId);
  }
}

function transformUrl(currentProduct, url, swicusOrgId) {
  if (currentProduct) {
    var parsedUrl = parseUrl(url, true);
    parsedUrl.query.utm_source = currentProduct;
    parsedUrl.query.utm_medium = 'app_switcher';

    if (swicusOrgId) {
      parsedUrl.query.swicus_org_id = swicusOrgId;
    }

    return parsedUrl.toString();
  }

  return url;
}

function shouldProductRedirectToLogin(productsStatus, productId) {
  var status = productsStatus[productId];
  return status === PRODUCT_STATUS.CAN_SWITCH || status === PRODUCT_STATUS.NO_STATUS || !status;
}

function createSignUpLink(currentProduct, environment, product) {
  return transformUrl(currentProduct, product.url.signup[environment]);
}